import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Footer from '../components/Footer';
import { useSafeBack } from '../hooks/useSafeBack';

const CONTACT_FORM_URL =
  'https://plugins.crisp.chat/urn:crisp.im:contact-form:0/contact/69def38c-82c4-4bad-8ab3-aafe4cee0339';

const Support = () => {
  const navigate = useNavigate();
  const { goBack } = useSafeBack('/');

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="mx-auto max-w-3xl px-4 py-8">
          {/* Back Button + Home */}
          <div className="flex items-center gap-2 mb-6">
            <Button
              variant="ghost"
              onClick={goBack}
              className="h-10 px-0 text-sm font-medium text-zinc-500 hover:text-zinc-900 hover:bg-transparent"
              data-testid="back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/dashboard')}
              className="h-8 w-8"
              data-testid="nav-home-btn"
              aria-label="Home"
            >
              <Home className="w-4 h-4 text-zinc-400" />
            </Button>
          </div>

          {/* Header */}
          <h1 className="text-3xl font-bold text-zinc-900 mb-3" data-testid="support-title">
            Support
          </h1>

          {/* Intro copy */}
          <p className="text-zinc-600 text-base sm:text-lg leading-relaxed mb-6" data-testid="support-intro">
            Need help? Send us a message and we&apos;ll get back to you as soon as possible.
          </p>

          {/* Contact form iframe */}
          <div
            className="w-full rounded-xl border border-zinc-200 bg-white overflow-hidden shadow-sm"
            data-testid="support-form-container"
          >
            <iframe
              title="Contact Form"
              src={CONTACT_FORM_URL}
              referrerPolicy="origin"
              sandbox="allow-forms allow-popups allow-scripts allow-same-origin"
              className="w-full block border-0 h-[700px] sm:h-[600px]"
              data-testid="support-form-iframe"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Support;
